import React, { Suspense } from "react";
import { Flex } from "@chakra-ui/react";
import SettlementManagementHeader from "@/features/my-order/features/settlement-management/components/SettlementManagementHeader";
import useSettlementManagementQuery from "@/features/my-order/features/settlement-management/hooks/useSettlementManagementQuery";
import SettlementManagementFeeContent from "@/features/my-order/features/settlement-management/components/fee/SettlementManagementFeeContent";
import SettlementManagementCreditContent from "@/features/my-order/features/settlement-management/components/credit/SettlementManagementCreditContent";
import { Helmet } from "react-helmet-async";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

function SettlementManagementPage() {
  const { t } = useI18nHelper();
  const { query } = useSettlementManagementQuery();
  // 오더 관리 그룹 공통 제목 — 오더 시트 목록과 같은 키를 같은 방식(t)으로 읽어 문자열을 일치시킨다.
  const pageTitle = `Pathrade | ${t("order_sheets")}`;
  const tabMapper = {
    FEE: <SettlementManagementFeeContent />,
    CREDIT: <SettlementManagementCreditContent />,
    DEPOSIT: <></>,
  };

  return (
    <Flex flexDirection={"column"} height={"100%"}>
      <Helmet>
        <title>{pageTitle}</title>
        <meta property="og:title" content={pageTitle} />
      </Helmet>
      <SettlementManagementHeader />
      {tabMapper[query.type ?? "FEE"]}
    </Flex>
  );
}

export default SettlementManagementPage;
